module.exports = __webpack_public_path__ + "img/prev.c6219153.png";